import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 z-40 cursor-pointer whitespace-nowrap"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}